/* eslint import/prefer-default-export: 0 */
import { createAction, createAsyncFormAction } from 'utils'
import * as CONSTANTS from './constants'

/* get the audits */
export const listAudits = createAsyncFormAction(CONSTANTS.LIST_AUDITS)
